import {getFlashFormData} from '../forms/form-flash-data';
import {config} from '../utils';

export const shippingDataChecks = () => {
  document.querySelectorAll('.js-submit-address-changes').forEach(el => {
    const form = el.closest('form') || el.form;
    const phone =
        document.querySelector('[name="user_data[s_user_phone]"]')?.value;
    getFlashFormData(form);
    el.addEventListener('click', e => {
      if (!document.querySelector('[name="acceptTermsAndConditions"]').checked) {
        if (config.section !== 'checkout') { e.preventDefault(); }
        document.querySelector('.js-must-accept-conditions-alert')
            .classList.remove('d-none');
          document.querySelector('[name="acceptTermsAndConditions"]')
              .classList.add('is-invalid');
        if (config.section === 'checkout') {
          window.scrollTo(0, document.body.scrollHeight);
        }
      }
    });
  });

  document.querySelectorAll('[name="acceptTermsAndConditions"]').forEach(el => {
    el.addEventListener('click', e => {
      if (document.querySelector('[name="acceptTermsAndConditions"]').checked) {
        document.querySelector('.js-must-accept-conditions-alert')
            .classList.add('d-none');
      }
    });
  });
}